import React from "react";

// mui components
import { Stack } from "@mui/material";

// custom components
import Body3 from "../typography/body-03";

// mui icons
import RouteOutlinedIcon from "@mui/icons-material/RouteOutlined";

// helper utils
import { DIRECT_PATH_CONSTANTS } from "../../utils/direct-path.constants";

// custom styles
import styles from "./index.module.scss";

const DirectPathBadge = () => {
	return (
		<Stack direction="row" className={styles.badgeContainer}>
			<RouteOutlinedIcon className={styles.badgeIcon} />
			<Body3
				text={DIRECT_PATH_CONSTANTS.BADGE_LABEL}
				fontType="semibold"
				extraClass={styles.badgeText}
			/>
		</Stack>
	);
};

export default DirectPathBadge;
